import ActionButton from "./ActionButton.vue";
import Boolean from "./Boolean.vue";
import Cascader from "./Cascader.vue";
import ChangeStatusButton from "./ChangeStatusButton.vue";
import Checkboxes from "./Checkboxes.vue";
import Date from "./Date.vue";
import Divider from "./Divider.vue";
import DiscussionThread from "./DiscussionThread.vue";
import Entity from "./Entity.vue";
import FileUpload from "./FileUpload.vue";
import AnswerReview from "./AnswerReview.vue";
import FormText from "./FormText.vue";
import MailingAddress from "./MailingAddress.vue";
import Money from "./Money.vue";
import Number from "./Number.vue";
import Heading from "./Heading.vue";
import RadioButtons from "./RadioButtons.vue";
import Repeater from "./Repeater.vue";
import RichText from "./RichText.vue";
import Section from "./Section.vue";
import SecurityGroup from "./SecurityGroup.vue";
import SelectList from "./SelectList.vue";
import SimpleText from "./SimpleText.vue";
import UserSelect from "./UserSelect.vue";
import ApplicationStatusSelect from "./ApplicationStatusSelect.vue";
import NameStamp from "./NameStamp.vue";
import LinkedAnswer from "./LinkedAnswer.vue";
import WorkflowAssociation from "./WorkflowAssociation.vue";
import ActivityDate from "./ActivityDate.vue";

import { type Component } from "vue";
import { FormElementType } from "~/api";
import ComplianceItem from "./Compliance/ComplianceItem.vue";

export const formComponentDict: Record<FormElementType, Component> = {
  [FormElementType.ACTION_BUTTON]: ActionButton,
  [FormElementType.BOOLEAN]: Boolean,
  [FormElementType.CASCADER]: Cascader,
  [FormElementType.CHANGE_STATUS_BUTTON]: ChangeStatusButton,
  [FormElementType.CHECKBOXES]: Checkboxes,
  [FormElementType.COMPLIANCE_ITEM]: ComplianceItem,
  [FormElementType.DATE]: Date,
  [FormElementType.DIVIDER]: Divider,
  [FormElementType.DISCUSSION]: DiscussionThread,
  [FormElementType.ENTITY]: Entity,
  [FormElementType.FILE_UPLOAD]: FileUpload,
  [FormElementType.ANSWER_REVIEW]: AnswerReview,
  [FormElementType.FORM_TEXT]: FormText,
  [FormElementType.MAILING_ADDRESS]: MailingAddress,
  [FormElementType.MONEY]: Money,
  [FormElementType.NUMBER]: Number,
  [FormElementType.HEADING]: Heading,
  [FormElementType.RADIO_BUTTONS]: RadioButtons,
  [FormElementType.REPEATER]: Repeater,
  [FormElementType.RICH_TEXT]: RichText,
  [FormElementType.SECTION]: Section,
  [FormElementType.SECURITY_GROUP]: SecurityGroup,
  [FormElementType.SELECT_LIST]: SelectList,
  [FormElementType.SIMPLE_TEXT]: SimpleText,
  [FormElementType.USER_SELECT]: UserSelect,
  [FormElementType.APPLICATION_STATUS_SELECT]: ApplicationStatusSelect,
  [FormElementType.NAME_STAMP]: NameStamp,
  [FormElementType.LINKED_ANSWER]: LinkedAnswer,
  [FormElementType.WORKFLOW_ASSOCIATION]: WorkflowAssociation,
  [FormElementType.ACTIVITY_DATE]: ActivityDate,
};
